const theme = {
  light: {
    name: 'light',
    background: 'var(--light)',
    text: 'var(--dark)',
    primary: '#0e3c54',
    red: '#de3319',
    lime: '#d8d951',
    green: '#78c17c',
    teal: '#12a9a0',
    maroon: '#b0321a',
    peach: '#f5bd73',
    orange: '#eab42d',
    cream: '#efe6dd',
    white: '#fff',
    gray: '#ada6a1',
    dark: '#302c2d',
    black: '#2f2a2b',
    slate: '#4d4d4d',
    silver: '#efe6dd',
  },
  dark: {
    name: 'light',
    background: 'var(--dark)',
    text: 'var(--light)',
    primary: '#103a56',
    red: '#de3119',
    green: '#d9d950',
    teal: '#12a9a0',
    maroon: '#b0321a',
    cream: '#efe6dd',
    white: '#fff',
    gray: '#ada6a1',
    darkGray: '#1f3341',
    black: '#2f2a2b',
    slate: '#4d4d4d',
    silver: '#efe6dd',
  },
}

export default theme
